var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"safe-chat-text"},_vm._l((_vm.parts),function(part,index){return _c('span',{key:index,class:{ 'safe-chat-text__match': part.highlight }},[_vm._v(_vm._s(part.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }